import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { IGameShowRunSettings } from 'app/teacher/gameshow/models/gameshow-run-settings';
import { GameShowService } from 'app/teacher/gameshow/services/gameshow.service';
import { TeacherService } from 'app/teacher/services/teacher.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GameShowSettingsResolver  {
  constructor(
    public readonly gameShowService: GameShowService,
    private readonly teacherService: TeacherService,) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<IGameShowRunSettings> {
    const classId = this.teacherService.activeClassInfo?.ClassId ?? '';
    const publicUnitId = route.paramMap.get('publicUnitId') ?? '';
    return this.gameShowService.getGameShowSettings(classId, publicUnitId);
  }
}
